import { FormControl } from "@angular/forms";

export const PostcodeValidator = (control: FormControl): any => {
	if (control.value) {
		const postcodeRegex = /^[0-9]{4}$/;
		const valid = postcodeRegex.test(control.value);
		return valid
			? null
			: {
					postcodeInvalid: {
						valid: false,
						message: "Please enter a valid postcode"
					}
			};
	}
};
